import { useState } from "react";
import * as v from "valibot";
import { useLang, plural } from "../../../services/lang";
import { useUser, UserInput } from "../../../components/User";
import { api, handleError } from "../../../services/api";
import { getLocalId } from "easy-analytics/client";
import { Checkbox } from "../../../components/Form";
import { Loading } from "../../../components";
import { UserSchema } from "../../../services/checkData";
import { PollClient, PollVotes } from "../../../../types";

export function PollVoting({ poll, vote, onChange }: { poll: PollClient, vote: PollVotes, onChange: (message: string) => void }) {
    const { dict } = useLang();
    const { user } = useUser();

    const [voteEdit, setVoteEdit] = useState<PollVotes>(vote);
    const [message, setMessage] = useState("");
    const [isSending, setIsSending] = useState(false);

    const voteCount = poll.voteCount;
    const userVoteCount = Object.values(voteEdit).filter(v => v === true).length;

    function handleCheckboxChange(option: string, value: boolean) {
        const newVote: PollVotes = { ...voteEdit, [option]: value };

        const newUserVoteCount = Object.values(newVote).filter(v => v === true).length;
        if (newUserVoteCount > voteCount) {
            setMessage(dict.pollVoteNotEnough);
            return;
        }

        setMessage("");
        setVoteEdit(newVote);
    }

    async function handleSave() {
        if (!v.safeParse(UserSchema, user).success) {
            setMessage(dict.userNameMissing);
            return;
        }
        if (userVoteCount < 1) {
            setMessage(dict.pollVoteMissing);
            return;
        }

        setIsSending(true);
        const [, error] = await api.updatePollVote({
            pollId: poll._id,
            vote: voteEdit,
            userId: getLocalId(),
            user,
        });
        setIsSending(false);

        if (error) {
            handleError(error);
            setMessage(dict.pollVoteError);
            return;
        }

        const message = dict.pollVoteSuccess;
        setMessage(message);
        onChange(message);
    }

    const sendMessage = !v.safeParse(UserSchema, user).success ? dict.userNameMissing
        : userVoteCount < 1 ? dict.pollVoteMissing
            : "";

    return <>
        <UserInput />
        <h2>{dict.pollVoteOptions}</h2>
        <p>{dict.pollVoteCount} {voteCount - userVoteCount} {plural(dict.vote, voteCount - userVoteCount)}.</p>
        <ul className="poll-options">
            {Object.keys(poll.options).map(option => <li key={option}>
                <label className={voteEdit[option] ? "checked" : ""} onClick={() => handleCheckboxChange(option, !voteEdit[option])}>
                    <Checkbox value={voteEdit[option]} />
                    {option}
                </label>
            </li>)}
        </ul>
        {message && <p className="alert">{message}</p>}

        {isSending && <Loading />}
        {!isSending && <>
            {sendMessage && <p className="info">{sendMessage}</p>}
            <button disabled={!!sendMessage} className="width" onClick={handleSave}>{dict.pollVoteSend}</button>
        </>}
    </>;
}
